import React from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Switch } from "react-router-dom";
import ScrollTopRoute from "components/ScrollTopRoute";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import PageTabs, { TAB } from "containers/BudgetHome/PageTabs";
import TabMessages, { MESSAGE_CODE } from "containers/BudgetHome/TabMessages";
import Overview from "./Overview";
import FarmDetails from "./FarmDetails";
import CompareBlocks from "./CompareBlocks";
import BlockDetails from "./BlockDetails";
import AnimalReports from "./AnimalReports";
import GHGReports from "./GHGReports";
import AnalysisComments from "./AnalysisComments";
import ReportActions from "./ReportActions";
import PlanningReport from "../Reporting/PlanningReport";
import Feasibility from "./Feasibility";
import PublicationActionsBar from "../../Publications/PublicationActionsBar";

const OverviewTab = (props) => {
    const { online, farm, budget, publication, authContext } = props;
    const dispatch = useDispatch();

    const reviewAnimalReports = () => {
        dispatch(push({ pathname: `/app/farm/${farm.id}/analysis/${budget.id}/overview/animalReports` }));
    };

    const baseUrl = `/app/farm/${farm.id}/analysis/${budget.id}/overview`;
    const tabs = {
        planning: { title: "Farm summary", path: `${baseUrl}`, exact: true },
        farmDetails: { title: "Farm details", path: `${baseUrl}/farmDetails`, exact: true },
        blocks: { title: "Block summary", path: `${baseUrl}/blocks`, exact: true },
        blockDetails: { title: "Block details", path: `${baseUrl}/blockDetails`, exact: true },
        compareBlocks: { title: "Compare blocks", path: `${baseUrl}/compareBlocks`, exact: true },
        animalReports: { title: "Animal reports", path: `${baseUrl}/animalReports`, exact: true },
        ghg: { title: "GHG", path: `${baseUrl}/ghg`, exact: true },
        feasibility: { title: "Feasibility", path: `${baseUrl}/feasibility`, exact: true },
        comments: { title: `Analysis comments (${(budget.comments || []).length})`, path: `${baseUrl}/comments`, exact: true },
    };

    if (authContext.accountType === "Student" || authContext.accountType === "EducationProvider") {
        delete tabs.feasibility;
    }

    return (
        <Panel title={budget.class === "PublishedAnalysis" && publication && "Published analysis"} referrer={`/app/farm/${farm.id}/analysis`}>
            {budget.class !== "PublishedAnalysis" && <PageTabs farmId={farm.id} budget={budget} tab={TAB.OVERVIEW} />}
            <PanelBody>
                {budget.class === "PublishedAnalysis" && publication && <PublicationActionsBar online={online} farm={farm} publishedAnalysis={budget} publication={publication} />}
                {budget.class !== "PublishedAnalysis" && <ReportActions farm={farm} budget={budget} />}
                <Panel tabs={tabs}>
                    <PanelBody>
                        <TabMessages farm={farm} budget={budget} publication={publication} tab={TAB.OVERVIEW} actions={{ [MESSAGE_CODE.ENGINE_ERROR]: reviewAnimalReports }} />
                        <Switch>
                            <ScrollTopRoute exact path={tabs.planning.path} render={(p) => <PlanningReport {...props} />} />
                            <ScrollTopRoute exact path={tabs.farmDetails.path} render={(p) => <FarmDetails {...props} />} />
                            <ScrollTopRoute exact path={tabs.blocks.path} render={(p) => <Overview {...props} />} />
                            <ScrollTopRoute exact path={tabs.blockDetails.path} render={(p) => <BlockDetails {...props} />} />
                            <ScrollTopRoute exact path={tabs.compareBlocks.path} render={(p) => <CompareBlocks {...props} />} />
                            <ScrollTopRoute exact path={tabs.animalReports.path} render={(p) => <AnimalReports {...props} />} />
                            <ScrollTopRoute exact path={tabs.ghg.path} render={(p) => <GHGReports {...props} />} />
                            {tabs.feasibility && <ScrollTopRoute exact path={tabs.feasibility.path} render={(p) => <Feasibility {...props} />} />}
                            <ScrollTopRoute exact path={tabs.comments.path} render={(p) => <AnalysisComments {...props} />} />
                        </Switch>
                    </PanelBody>
                </Panel>
            </PanelBody>
        </Panel>
    );
};

export default OverviewTab;
